/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../../shared/generated.types'

import { api } from '../../../utils'
export const AuditEntryFragment = `
    fragment AuditEntryFragment on AuditEntry {
  date
  reference {
    id
    type
    display
  }
}
    `
export const TokenResponse = `
    fragment TokenResponse on ConfirmOTPResponse {
  access_token
  expires_in
}
    `
export const FileFragment = `
    fragment FileFragment on File {
  mimeType
  name
  url
}
    `
export const EligibilityVerificationFragment = `
    fragment EligibilityVerificationFragment on EligibilityVerification {
  ts
  isActive
  insurancePlanId
}
    `
export const BillingInsuredExternalFragment = `
    fragment BillingInsuredExternalFragment on BillingInsured {
  id
  type
  eligibilityVerified
  eligibilityVerification {
    ...EligibilityVerificationFragment
  }
  insurancePlanId
  outOfNetwork
  outOfNetworkPlan {
    state {
      code
      name
    }
    name
  }
  idNumber
  coPay
  deductible
  familyDeductible
  coinsurance
}
    `
export const BillingExternalFragment = `
    fragment BillingExternalFragment on PatientBilling {
  id
  treatmentId
  patientId
  insurances {
    ...BillingInsuredExternalFragment
  }
}
    `
export const SavePatientBillingExternalDocument = `
    mutation savePatientBillingExternal($input: SavePatientBillingExternalInput!) {
  savePatientBillingExternal(input: $input) {
    success
  }
}
    `
export const CreatePatientSubmissionDocument = `
    mutation createPatientSubmission($input: CreatePatientRegistrationSubmission!) {
  createPatientRegistrationSubmission(input: $input) {
    submissionId
    success
    message
    metaData {
      pendingVerificationOrdinalities
    }
  }
}
    `
export const UpdatePatientSubmissionDocument = `
    mutation updatePatientSubmission($input: UpdatePatientRegistrationSubmission!) {
  updatePatientRegistrationSubmission(input: $input) {
    submissionId
    success
    message
    metaData {
      pendingVerificationOrdinalities
    }
  }
}
    `
export const CompletePatientSubmissionDocument = `
    mutation completePatientSubmission($input: CompletePatientRegistrationSubmission!) {
  completePatientRegistrationSubmission(input: $input) {
    submissionId
    success
    message
  }
}
    `
export const CreateConsentPacketExternalDocument = `
    mutation createConsentPacketExternal($primaryEmail: String!, $language: String!, $redirectUrl: String) {
  createConsentPacketExternal(
    content: {preferredLanguage: $language, primaryEmail: $primaryEmail, redirectUrl: $redirectUrl}
  ) {
    success
    code
    message
  }
}
    `
export const GetExternalLanguagesDocument = `
    query getExternalLanguages {
  getExternalLanguages {
    code
    display
  }
}
    `
export const GetExternalInsurancePlansDocument = `
    query getExternalInsurancePlans {
  getExternalInsurancePlans {
    _id
    name
    stateCode
    payerId
    payerName
    verificationPayerId
    verificationPayerName
    tocConfiguration {
      referralSourceFilter
      fuh7
      fuh30
      fum7
      fum30
    }
  }
}
    `
export const GetExternalPracticeStatesDocument = `
    query getExternalPracticeStates($programCode: String) {
  getExternalPracticeStates(input: {programCode: $programCode}) {
    stateCode
    availabilityStatus
  }
}
    `
export const LoadPatientBillingExternalDocument = `
    query loadPatientBillingExternal {
  loadPatientBillingExternal {
    ...BillingExternalFragment
  }
}
    ${BillingExternalFragment}
${BillingInsuredExternalFragment}
${EligibilityVerificationFragment}`
export const GetAgreementIsSignedDocument = `
    query getAgreementIsSigned {
  getAgreementIsSigned {
    signed
  }
}
    `
export const GetSigningUrlExternalDocument = `
    query getSigningUrlExternal {
  getSigningUrlExternal {
    code
    message
    signingUrl
  }
}
    `

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    savePatientBillingExternal: build.mutation<
      Types.SavePatientBillingExternal,
      Types.SavePatientBillingExternalVariables
    >({
      query: (variables) => ({
        document: SavePatientBillingExternalDocument,
        variables,
      }),
    }),
    createPatientSubmission: build.mutation<
      Types.CreatePatientSubmission,
      Types.CreatePatientSubmissionVariables
    >({
      query: (variables) => ({
        document: CreatePatientSubmissionDocument,
        variables,
      }),
    }),
    updatePatientSubmission: build.mutation<
      Types.UpdatePatientSubmission,
      Types.UpdatePatientSubmissionVariables
    >({
      query: (variables) => ({
        document: UpdatePatientSubmissionDocument,
        variables,
      }),
    }),
    completePatientSubmission: build.mutation<
      Types.CompletePatientSubmission,
      Types.CompletePatientSubmissionVariables
    >({
      query: (variables) => ({
        document: CompletePatientSubmissionDocument,
        variables,
      }),
    }),
    createConsentPacketExternal: build.mutation<
      Types.CreateConsentPacketExternal,
      Types.CreateConsentPacketExternalVariables
    >({
      query: (variables) => ({
        document: CreateConsentPacketExternalDocument,
        variables,
      }),
    }),
    getExternalLanguages: build.query<
      Types.GetExternalLanguages,
      Types.GetExternalLanguagesVariables | void
    >({
      query: (variables) => ({
        document: GetExternalLanguagesDocument,
        variables,
      }),
    }),
    getExternalInsurancePlans: build.query<
      Types.GetExternalInsurancePlans,
      Types.GetExternalInsurancePlansVariables | void
    >({
      query: (variables) => ({
        document: GetExternalInsurancePlansDocument,
        variables,
      }),
    }),
    getExternalPracticeStates: build.query<
      Types.GetExternalPracticeStates,
      Types.GetExternalPracticeStatesVariables | void
    >({
      query: (variables) => ({
        document: GetExternalPracticeStatesDocument,
        variables,
      }),
    }),
    loadPatientBillingExternal: build.query<
      Types.LoadPatientBillingExternal,
      Types.LoadPatientBillingExternalVariables | void
    >({
      query: (variables) => ({
        document: LoadPatientBillingExternalDocument,
        variables,
      }),
    }),
    getAgreementIsSigned: build.query<
      Types.GetAgreementIsSigned,
      Types.GetAgreementIsSignedVariables | void
    >({
      query: (variables) => ({
        document: GetAgreementIsSignedDocument,
        variables,
      }),
    }),
    getSigningUrlExternal: build.query<
      Types.GetSigningUrlExternal,
      Types.GetSigningUrlExternalVariables | void
    >({
      query: (variables) => ({
        document: GetSigningUrlExternalDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
